// Development server
 //export const FIS_BACKEND = "http://52.77.35.146:8080/FIS";
 export const ucp_BACKEND = "https://ucp.clsslabs.com/whatsappService/whatsapp";
 export const FIS_BACKEND = "https://fisdev.clsslabs.com/FIS";


// export const FIS_BACKEND = "http://10.10.10.209:8080/FIS";
// Production server
// export const FIS_BACKEND = "https://fis.clsslabs.com/FIS";

// export const FIS_BACKEND = "http://65.2.105.254:8082/FIS/"
// export const FIS_BACKEND = "http://fis.clsslabs.com/FIS/"
// export const FIS_BACKEND = "http://fis.clsslabs.com:8082/FIS"

/* export const FIS_BACKEND = "http://10.10.10.77:8080/FIS"  */

// localhost:8082
// http://localhost:3000/
// http://65.2.105.254:8082
// "homepage": "http://localhost:3000/",
// "homepage": "http://localhost:8082",
// "homepage": "http://localhost:8082/FIS",
// "homepage": "http://65.2.105.254:8082",
// "homepage": "http://65.2.105.254:8082"
